interface MoneyBackGuaranteeProps {
    /** Optional wrapper className override. Defaults to a simple text block. */
    className?: string;
}

/**
 * Consistent "60-day money-back guarantee" messaging used across
 * billing / checkout / trial surfaces.
 */
export default function MoneyBackGuarantee({ className }: MoneyBackGuaranteeProps) {
    return (
        <p className={className ?? "text-sm text-gray-600"}>
            Every paid plan includes a <span className="font-semibold text-max-800">60-day money-back guarantee</span>.
            No questions asked.
        </p>
    );
}
